export default "__VITE_ASSET__db7aaa8a__"